import { KEY_NAME_SIDEBAR_MODULE } from '../constants/sidebarMenuConfigs';
import { socketConfigs } from '../constants/socketConfigs';
import { socketDispatchApi } from './socketUtils';

const SOCKET_DRIVER_CHANNEL = [
  'FleetDriverLocation',
  'FleetDriverOnlineStatus',
  'FleetDriverInfo'
];
const SOCKET_BOOKING_CHANNEL = [
  'FleetBooking',
];

let isSubscribeDriverChannel = false;
let isSubscribeBookingChannel = false;

export const unSubscribeDriverChannel = (fleetId) => {
  if(isSubscribeDriverChannel) {
    isSubscribeDriverChannel = false;
    SOCKET_DRIVER_CHANNEL.map((channel) => {
      socketDispatchApi.emit(socketConfigs.send.unSubscribe, {
        channel,
        fleetId,
      });
    });
  }
};

export const unSubscribeBookingChannel = (fleetId) => {
  if(isSubscribeBookingChannel) {
    isSubscribeBookingChannel = false;
    SOCKET_BOOKING_CHANNEL.map((channel) => {
      socketDispatchApi.emit(socketConfigs.send.unSubscribe, {
        channel,
        fleetId,
      });
    });
  }
};

export const subscribeDriverChannel = (fleetId) => {
  isSubscribeDriverChannel = true;
  SOCKET_DRIVER_CHANNEL.map((channel) => {
    socketDispatchApi.emit(socketConfigs.send.subscribe, {
      channel,
      fleetId,
    });
  });
};

export const subscribeBookingChannel = (fleetId) => {
  isSubscribeBookingChannel = true;
  SOCKET_BOOKING_CHANNEL.map((channel) => {
    socketDispatchApi.emit(socketConfigs.send.subscribe, {
      channel,
      fleetId,
    });
  });
};


export const handleSubscribeSocketWhenChangeModule = (params) => {
  const {
    newModule,
    fleetId
  } = params
  if(newModule === KEY_NAME_SIDEBAR_MODULE.map) {
    subscribeDriverChannel(fleetId);
    subscribeBookingChannel(fleetId);
    return;
  }

  if(newModule === KEY_NAME_SIDEBAR_MODULE.cue) {
    subscribeBookingChannel(fleetId);
    unSubscribeDriverChannel(fleetId);
    return;
  }

  unSubscribeDriverChannel(fleetId);
  unSubscribeBookingChannel(fleetId);

}
